import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import EditSex from '../assembly/editSex/index';
import EditBirthday from '../assembly/editBirthday/index';
import EditVaus from '../assembly/editVAu/index';
import SelectData from '../assembly/selectData/index';
import SelectMemberPushMessages from '../assembly/selectPushMessages/index';
import MemberFreezeRecords from '../../memberFreezeRecords/edit/index';
import MemberLink from '@/views/system/memberTourists/memberLink/index';
import EditMemberAll from '../assembly/editMemberAll/index';
import { Message } from 'element-ui';
export default {
  components: {
    EditSex: EditSex,
    EditBirthday: EditBirthday,
    EditVaus: EditVaus,
    SelectData: SelectData,
    SelectMemberPushMessages: SelectMemberPushMessages,
    MemberFreezeRecords: MemberFreezeRecords,
    MemberLink: MemberLink,
    EditMemberAll: EditMemberAll
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MemberEdit',
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isUpdateInfo1: this.checkauthority('update_sex_info'),
      isUpdateInfo2: this.checkauthority('update_bosdy_info'),
      isUpdateInfo3: this.checkauthority('add_v_auth_info'),
      isUpdateInfo4: this.checkauthority('update_push_message_info_list'),
      isUpdateInfo5: this.checkauthority('member_info_user_data'),
      isUpdateInfo6: this.checkauthority('member_info_tuijian'),
      isUpdateInfo7: this.checkauthority('member_info_dongjie'),
      isUpdateInfo8: this.checkauthority('member_info_yongjiu_dongjie'),
      isUpdateInfo9: this.checkauthority('member_del'),
      freezeRecordsDialogVisible: false,
      freezeRecordsDisabled: false,
      editMemberInfoDialogVisible: false,
      editMemberInfoDisabled: false,
      selectDataDialogVisible: false,
      selectDataDisabled: true,
      editVauDialogVisible: false,
      editVauDisabled: false,
      editBirthdayDialogVisible: false,
      editBirthdayDisabled: false,
      editSexDialogVisible: false,
      editSexDisabled: false,
      memberLinkDialogVisible: false,
      editMemberAllDialogVisible: false,
      cityNameMap: null,
      title: '',
      form: {
        memberId: null,
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        vAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        memberInfo: null,
        marriage: '',
        height: '',
        weight: '',
        homeTop: null,
        idNo: '',
        nativePlace: '',
        displaySts: 0,
        noRegsterHomeIndex: 0,
        updateDedicatedToMembershipApi: 0,
        wxchatUserName: null
      },
      sexs: [],
      marriages: [],
      educations: [],
      zodiacs: [],
      constellations: [],
      nations: [],
      politicalOutlooks: [],
      memberRankingAtHomes: [],
      memberOccupations: [],
      memberIndustrys: [],
      memberCompanyTypes: [],
      memberPosts: [],
      memberPostTypes: [],
      memberAnnualIncomes: [],
      memberSmokes: [],
      memberDrinks: [],
      carPurchases: [],
      buyHouses: [],
      pics: []
    };
  },
  methods: {
    updateDedicatedToMembershipApi: function updateDedicatedToMembershipApi(top) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var pro;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this.form.memberId,
                dedicatedToMembership: top
              };
              _this.form.dedicatedToMembership = top;
              _context.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    closeMemberLink: function closeMemberLink() {
      this.memberLinkDialogVisible = false;
    },
    editMemberAllOpen: function editMemberAllOpen() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var fresh;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.$refs.editMemberAll.setTitle('修改完善');
              // 重新拉取最新原始数据，避免用详情页缓存的旧数据/转换文本导致回显为空
              _context2.n = 1;
              return _this2.getFreshMemberData(_this2.form.memberId);
            case 1:
              fresh = _context2.v;
              _context2.n = 2;
              return _this2.$refs.editMemberAll.setData(fresh, _this2.pics);
            case 2:
              _this2.editMemberAllDialogVisible = true;
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getFreshMemberData: function getFreshMemberData(memberId) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var memberRes, infoRes, member, info;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.GET_MEMBER_INFO({
                memberId: memberId
              });
            case 1:
              memberRes = _context3.v;
              _context3.n = 2;
              return api.GET_MEMBERINFO_INFO({
                memberId: memberId
              });
            case 2:
              infoRes = _context3.v;
              member = memberRes.body || {};
              info = infoRes.body || {}; // 合并会员主表(by_member)与个人信息表(member_info)的最新原始数据
              return _context3.a(2, Object.assign({}, member, info));
          }
        }, _callee3);
      }))();
    },
    editMemberAllClose: function editMemberAllClose() {
      this.editMemberAllDialogVisible = false;
    },
    editMemberAllInitData: function editMemberAllInitData() {
      this.$emit('initTableData');
      if (this.form.memberId) {
        this.getMemberInfoApi(this.form.memberId, this.form);
      }
    },
    resetMemberLink: function resetMemberLink() {
      var par = [this.form.memberId];
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.memberLinkDialogVisible = true;
      this.$refs.memberLink.setTitle('关联账号');
      this.$refs.memberLink.initData(par);
    },
    cancelMatchmakerRelation: function cancelMatchmakerRelation() {
      var _this3 = this;
      this.$confirm('确定要取消该会员红娘绑定关系吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.cancelMatchmakerRelationApi();
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    cancelMatchmakerRelationApi: function cancelMatchmakerRelationApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var pro;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              pro = {
                memberId: _this4.form.memberId
              };
              _context4.n = 1;
              return api.cancelMemberMatchmakerRelation(pro);
            case 1:
              _this4.$message.success('操作成功');
              _this4.$emit('initTableData');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    ifPicUrl: function ifPicUrl(url) {
      if (url.indexOf('http') !== -1) {
        return url;
      }
      return this.downloadUrl + url;
    },
    permanentFreeze: function permanentFreeze() {
      var _this5 = this;
      this.$confirm('确定要永久冻结会员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.updateFreeze();
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消冻结'
        });
      });
    },
    freezeRecordsInitData: function freezeRecordsInitData() {
      this.$emit('initTableData');
    },
    freezeRecordsOpen: function freezeRecordsOpen() {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsOpen2: function freezeRecordsOpen2() {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData2(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsClose: function freezeRecordsClose() {
      this.freezeRecordsDialogVisible = false;
    },
    updateFreeze: function updateFreeze() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pro;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              pro = {
                memberId: _this6.form.memberId,
                type: 2,
                remarks: '永久冻结'
              };
              _context5.n = 1;
              return api.SAVE_MEMBERFREEZERECORDS(pro);
            case 1:
              _this6.$emit('initTableData');
              _this6.$message.success('操作成功');
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    editMemberInfoDataInitData: function editMemberInfoDataInitData() {
      this.$emit('initTableData');
    },
    editMemberInfoOpen: function editMemberInfoOpen() {
      this.$refs.selectMemberPushMessages.setTitle('推送记录');
      this.$refs.selectMemberPushMessages.initTableData(this.form);
      this.editMemberInfoDialogVisible = true;
    },
    editMemberInfoClose: function editMemberInfoClose() {
      this.editMemberInfoDialogVisible = false;
    },
    selectDataInitData: function selectDataInitData() {
      this.$emit('initTableData');
    },
    selectDataOpen: function selectDataOpen() {
      this.$refs.selectData.setTitle('用户数据');
      this.$refs.selectData.getMemberDatas(this.form);
      this.selectDataDialogVisible = true;
    },
    selectDataClose: function selectDataClose() {
      this.selectDataDialogVisible = false;
    },
    editVauInitData: function editVauInitData() {
      this.$emit('initTableData');
    },
    editVauOpen: function editVauOpen() {
      this.$refs.editVau.setTitle('加V认证');
      this.$refs.editVau.setData(this.form);
      this.editVauDialogVisible = true;
    },
    editVauClose: function editVauClose() {
      this.editVauDialogVisible = false;
    },
    editBirthdayInitData: function editBirthdayInitData(time) {
      this.form.birthday = time;
      this.$emit('initTableData');
    },
    editBirthdayOpen: function editBirthdayOpen() {
      this.$refs.editBirthday.setTitle('修改出生日期');
      this.$refs.editBirthday.setData(this.form);
      this.editBirthdayDialogVisible = true;
    },
    editBirthdayClose: function editBirthdayClose() {
      this.editBirthdayDialogVisible = false;
    },
    editSexInitData: function editSexInitData(sex) {
      // this.form.sex = this.enums.checkEnumsValue(this.sexs, sex, '')
      this.form.sex = sex;
      this.$emit('initTableData');
    },
    editSexOpen: function editSexOpen() {
      this.$refs.editSex.setTitle('修改性别');
      this.$refs.editSex.setData(this.form);
      this.editSexDialogVisible = true;
    },
    editSexClose: function editSexClose() {
      this.editSexDialogVisible = false;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                name: name
              };
              _context6.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context6.v;
              _this7.enumList = res.body;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.memberId = null;
      this.form.nickName = null;
      this.form.sex = null;
      this.form.name = null;
      this.form.headUrl = null;
      this.form.phone = null;
      this.form.userName = null;
      this.form.passWord = null;
      this.form.wxMiniOpenid = null;
      this.form.loginTime = null;
      this.form.loginNum = null;
      this.form.loginDevice = null;
      this.form.province = null;
      this.form.city = null;
      this.form.area = null;
      this.form.longitude = null;
      this.form.latitude = null;
      this.form.vAuth = null;
      this.form.memberType = null;
      this.form.privateLetterNum = null;
      this.form.acceptNum = null;
      this.form.memberStartTime = null;
      this.form.memberEndTime = null;
      this.form.warningsNum = null;
      this.form.currencyNum = null;
      this.form.memberSts = null;
      this.form.createTime = null;
      this.form.memberNo = null;
      this.form.source = null;
      this.form.memberInfo = null;
      this.form.homeTop = 0;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.getEnumsApi();
      this.form = {};
      this.getMemberInfoApi(data.memberId, data);
    },
    getEnumsApi: function getEnumsApi() {
      var thiz = this;
      this.enums.sexEnums(function (arg) {
        thiz.sexs = arg.body;
      });
      this.enums.getMbmberMarriages(function (arg) {
        thiz.marriages = arg.body;
      });
      this.enums.getEducations(function (arg) {
        thiz.educations = arg.body;
      });
      this.enums.getZodiacs(function (arg) {
        thiz.zodiacs = arg.body;
      });
      this.enums.getConstellations(function (arg) {
        thiz.constellations = arg.body;
      });
      this.enums.getNations(function (arg) {
        thiz.nations = arg.body;
      });
      thiz.enums.getMemberPoliticalOutlooks(function (arg) {
        thiz.politicalOutlooks = arg.body;
      });
      this.enums.getMemberRankingAtHomes(function (arg) {
        thiz.memberRankingAtHomes = arg.body;
      });
      this.enums.getMemberOccupations(function (arg) {
        thiz.memberOccupations = arg.body;
      });
      this.enums.getMemberIndustrys(function (arg) {
        thiz.memberIndustrys = arg.body;
      });
      this.enums.getMemberCompanyTypes(function (arg) {
        thiz.memberCompanyTypes = arg.body;
      });
      this.enums.getMemberPosts(function (arg) {
        thiz.memberPosts = arg.body;
      });
      this.enums.getMemberPostTypes(function (arg) {
        thiz.memberPostTypes = arg.body;
      });
      this.enums.getMemberAnnualIncomes(function (arg) {
        thiz.memberAnnualIncomes = arg.body;
      });
      this.enums.getMemberSmokes(function (arg) {
        thiz.memberSmokes = arg.body;
      });
      this.enums.getMemberDrinks(function (arg) {
        thiz.memberDrinks = arg.body;
      });
      this.enums.getBuyHouse(function (arg) {
        thiz.buyHouses = arg.body;
      });
      this.enums.getCarPurchase(function (arg) {
        thiz.carPurchases = arg.body;
      });
    },
    getMemberInfoApi: function getMemberInfoApi(memberId, data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var pro, memberRes, memberData, cleanMember, ls, res, nativeCitys;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              pro = {
                memberId: memberId
              }; // 拉取最新会员数据，避免详情页显示修改前的旧数据
              _context7.n = 1;
              return api.GET_MEMBER_INFO(pro);
            case 1:
              memberRes = _context7.v;
              memberData = memberRes.body || {}; // 过滤null字段，避免覆盖data里已有的值(如memberCitys等exist=false字段后端返回null)
              cleanMember = {};
              Object.keys(memberData).forEach(function (k) {
                if (memberData[k] !== null && memberData[k] !== undefined) {
                  cleanMember[k] = memberData[k];
                }
              });
              ls = Object.assign({}, data, cleanMember);
              _context7.n = 2;
              return api.GET_MEMBERINFO_INFO(pro);
            case 2:
              res = _context7.v;
              _this8.fileList = [];
              _this8.getPicsApi(memberId);
              res.body.height = (res.body.height + '').replace(/cm+$/i, '') + 'cm';
              res.body.weight = (res.body.weight + '').replace(/kg+$/i, '') + 'kg';
              res.body.nation = _this8.enums.checkEnumsValue(_this8.nations, res.body.nation, '');
              res.body.constellation = _this8.enums.checkEnumsValue(_this8.constellations, res.body.constellation, '');
              res.body.politicalOutlook = _this8.enums.checkEnumsValue(_this8.politicalOutlooks, res.body.politicalOutlook, '');
              res.body.rankingAtHome = _this8.enums.checkEnumsValue(_this8.memberRankingAtHomes, res.body.rankingAtHome, '');
              // res.body.occupation = this.enums.checkEnumsValue(this.memberOccupations, res.body.occupation, '')
              res.body.industry = _this8.enums.checkEnumsValue(_this8.memberIndustrys, res.body.industry, '');
              res.body.companyType = _this8.enums.checkEnumsValue(_this8.memberCompanyTypes, res.body.companyType, '');
              res.body.postNature = _this8.enums.checkEnumsValue(_this8.memberPostTypes, res.body.postNature, '');
              res.body.post = _this8.enums.checkEnumsValue(_this8.memberPosts, res.body.post, '');
              res.body.annualIncome = _this8.enums.checkEnumsValue(_this8.memberAnnualIncomes, res.body.annualIncome, '');
              res.body.smoke = _this8.enums.checkEnumsValue(_this8.memberSmokes, res.body.smoke, '');
              res.body.drink = _this8.enums.checkEnumsValue(_this8.memberDrinks, res.body.drink, '');

              // 主表枚举字段最新原始值转文本显示
              ls.education = _this8.enums.checkEnumsValue(_this8.educations, ls.education, '');
              ls.marriage = _this8.enums.checkEnumsValue(_this8.marriages, ls.marriage, '');
              ls.carPurchase = _this8.enums.checkEnumsValue(_this8.carPurchases, ls.carPurchase, '');
              ls.buyHouse = _this8.enums.checkEnumsValue(_this8.buyHouses, ls.buyHouse, '');
              // 性别兼容老数据main/man/women，统一显示中文
              if (ls.sex === 'main' || ls.sex === 'man') {
                ls.sex = '男';
              } else if (ls.sex === 'women') {
                ls.sex = '女';
              }
              // 根据最新城市code重建城市名(修改完善保存后工作城市同步更新)
              _context7.n = 3;
              return _this8.buildMemberCitys(ls.province, ls.city, ls.area);
            case 3:
              ls.memberCitys = _context7.v;
              ls.cityCode = ls.cityCode || ls.city;
              ls.provinceCode = ls.provinceCode || ls.province;
              ls.areaCode = ls.areaCode || ls.area;
              ls.city = JSON.stringify(ls.memberCitys);
              // ls.sex = this.enums.checkEnumsValue(this.sexs, ls.sex, '')
              // ls.marriage = this.enums.checkEnumsValue(this.marriages, ls.marriage, '')
              // ls.education = this.enums.checkEnumsValue(this.educations, ls.education, '')
              // res.body.zodiac = this.enums.checkEnumsValue(this.zodiacs, res.body.zodiac, '')
              _this8.form = Object.assign(ls, res.body);
              // 家乡籍贯：只存了省/市code没存文本时，用城市树名称拼出显示文本，避免详情页空白
              if (!(!_this8.form.nativePlace && (_this8.form.nativeProvince || _this8.form.nativeCity))) {
                _context7.n = 5;
                break;
              }
              _context7.n = 4;
              return _this8.buildMemberCitys(_this8.form.nativeProvince, _this8.form.nativeCity);
            case 4:
              nativeCitys = _context7.v;
              if (nativeCitys.length) {
                _this8.form.nativePlace = nativeCitys.join(' ');
              }
            case 5:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    buildMemberCitys: function buildMemberCitys(province, city, area) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var codes, res, tree, map, thiz, citys, j, name;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              codes = [province, city, area].filter(function (c) {
                return c !== null && c !== undefined && c !== '';
              });
              if (!(codes.length === 0)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, []);
            case 1:
              if (_this9.cityNameMap) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 2:
              res = _context8.v;
              tree = res.body || [];
              map = {};
              thiz = _this9;
              (function walk(nodes) {
                for (var i = 0; i < nodes.length; i++) {
                  map[nodes[i].value] = nodes[i].label;
                  if (nodes[i].children && nodes[i].children.length) {
                    walk(nodes[i].children);
                  }
                }
              })(tree);
              thiz.cityNameMap = map;
            case 3:
              citys = [];
              for (j = 0; j < codes.length; j++) {
                name = _this9.cityNameMap[codes[j] + ''];
                if (name) {
                  citys.push(name);
                }
              }
              return _context8.a(2, citys);
          }
        }, _callee8);
      }))();
    },
    deleteMember: function deleteMember() {
      var _this0 = this;
      this.$confirm('确定要删除会员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this0.deleteMemberApi();
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteMemberApi: function deleteMemberApi() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var pro;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              pro = {
                memberId: _this1.form.memberId
              };
              _context9.n = 1;
              return api.DELETE_MEMBER(pro);
            case 1:
              _this1.$message.success('操作成功');
              _this1.handleClose();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getPicsApi: function getPicsApi(memberId) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var pro, res, fileList, i, file;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              pro = {
                memberId: memberId
              };
              _context0.n = 1;
              return api.GET_MEMBERPICTURES_LIST(pro);
            case 1:
              res = _context0.v;
              _this10.pics = res.body;
              fileList = [];
              for (i = 0; i < _this10.pics.length; i++) {
                file = {
                  name: '1111',
                  url: _this10.ifPicUrl(_this10.pics[i])
                };
                fileList.push(file);
              }
              _this10.fileList = fileList;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    updateHomeTopApi: function updateHomeTopApi(top) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var pro;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this11.form.memberId,
                homeTop: top
              };
              _this11.form.homeTop = top;
              _context1.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this11.$emit('initTableData');
              _this11.$message.success('操作成功');
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    updateHomeTopApi2: function updateHomeTopApi2(top) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var pro;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this12.form.memberId,
                noRegsterHomeIndex: top
              };
              _this12.form.noRegsterHomeIndex = top;
              _context10.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this12.$emit('initTableData');
              _this12.$message.success('操作成功');
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    /**
     * 隐藏 - 取消隐藏
     * @returns {Promise<void>}
     */
    updateMemberDisplaySts: function updateMemberDisplaySts() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var pro;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              pro = {
                memberId: _this13.form.memberId,
                displaySts: _this13.form.displaySts === 0 ? 1 : 0
              };
              _this13.form.displaySts = _this13.form.displaySts === 0 ? 1 : 0;
              _context11.n = 1;
              return api.UPDATE_MEMBER_DISPLAY(pro);
            case 1:
              _this13.$message.success('操作成功');
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    updateApi: function updateApi() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return api.UPDATE_MEMBER(_this14.form);
            case 1:
              _this14.$emit('initTableData');
              _this14.$message.success('操作成功');
              _this14.handleClose();
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    saveApi: function saveApi() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return api.SAVE_MEMBER(_this15.form);
            case 1:
              _this15.$emit('initTableData');
              _this15.$message.success('操作成功');
              _this15.handleClose();
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    save: function save() {
      var _this16 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this16.form.memberId != null) {
            _this16.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this16.updateApi();
            }).catch(function () {
              _this16.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this16.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};